<div class="modal-content">
    <div class="modal-body text-center">
        <h3 class="modal-title mb-3" id="CancelOrderTitle">Cancel Order</h3>
        <p class="font-size-18 mb-3">Are you sure you want to cancel order?</p>
        <div class="mb-4">
            <span class="badge badge-danger text-wrap text-left lh-normal">Note: No charges are applied & amount will be refunded into your bank account.</span>
        </div>
        <div class="form-row">
            <div class="col">
                <button type="button" class="btn btn-secondary-theme-outline btn-lg btn-block" data-dismiss="modal" (click)="onClose()">No</button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-primary-theme btn-lg btn-block" data-dismiss="modal" data-toggle="modal" data-target="#AddBankInfo" (click)="onCancel()">Yes</button>
            </div>
        </div>
    </div>
</div>